import { normalizeMeetingTime } from './timeCombobox.js'

const MINUTES_PER_DAY = 24 * 60

function timeToMinutes(value) {
  const normalized = normalizeMeetingTime(value)

  if (normalized === null) {
    return null
  }

  const [hours, minutes] = normalized.split(':').map(Number)

  return hours * 60 + minutes
}

export function addMinutesWrapped(value, duration) {
  const start = timeToMinutes(value)

  if (
    start === null ||
    !Number.isInteger(duration) ||
    duration <= 0 ||
    duration >= MINUTES_PER_DAY
  ) {
    return null
  }

  const end = (start + duration) % MINUTES_PER_DAY

  return `${String(Math.floor(end / 60)).padStart(2, '0')}:${String(end % 60).padStart(2, '0')}`
}

export function coupledMeetingEnd({ start, previousStart, end }) {
  const rawEnd = String(end ?? '').trim()
  const startMinutes = timeToMinutes(start)
  const previousStartMinutes = timeToMinutes(previousStart)
  const endMinutes = timeToMinutes(end)

  if (startMinutes === null) {
    return null
  }

  if (endMinutes === null) {
    return rawEnd === '' ? addMinutesWrapped(start, 120) : null
  }

  if (previousStartMinutes === null || endMinutes === previousStartMinutes) {
    return null
  }

  const duration = (endMinutes - previousStartMinutes + MINUTES_PER_DAY) % MINUTES_PER_DAY

  return addMinutesWrapped(start, duration)
}

export default function meetingTimeRange() {
  return {
    timeCommitted(event) {
      const detail = event.detail ?? {}

      if (detail.role !== 'start' || detail.value === '') {
        return
      }

      const endField = this.$root.querySelector('[data-time-role="end"]')
      const endModel = endField?.querySelector('[data-time-model]')
      const end = coupledMeetingEnd({
        start: detail.value,
        previousStart: detail.previousValue,
        end: endModel?.value ?? ''
      })

      if (end === null) {
        return
      }

      endField.dispatchEvent(new CustomEvent('time-combobox:set', {
        detail: { value: end }
      }))
    }
  }
}
